import React, { useEffect } from 'react';
import CreativeEditor from '@cesdk/cesdk-js/react';
import { initVideoPlaceholdersCreatorEditor } from '../imgly/index.ts';
import AppApi from '../shared/App.api';

// This page can be removed once video templates are implemented properly into the normal "Templates" page
export default function VideoTemplates() {
  const [editor, setEditor] = React.useState(null);

  useEffect(() => {
    const getLicenseKey = async () => {
      try {
        const res = await AppApi.get('/admin/web-cesdk-license-key');
        setEditor(
          <CreativeEditor
            config={{
              license: res.data.licenseKey,
              baseURL: '/assets',
            }}
            init={initVideoPlaceholdersCreatorEditor}
            width="100%"
            height="70vh"
          />
        );
      } catch (err) {
        console.error('Error getting CE.SDK license key:', err);
      }
    };

    getLicenseKey();
  }, []);

  return <>{editor && editor}</>;
}
